// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';
import {PageStatus} from '../page-status';
import {MergeCustomerStatus} from './merge-customer-status';
import {CustomerSearchError} from './customer-search-error';

export const ApplicationStatus = t.struct({
    areCitiesLoaded: PageStatus,
    areStateFacetsLoaded: PageStatus,
    breadcrumbTitle: t.String,
    customerSearchError: CustomerSearchError,
    fullPageLoadingStatus: PageStatus,
    hasSearchStarted: t.Boolean,
    isRestoreDefaultFacetShown: t.Boolean,
    isSaveDefaultFacetShown: t.Boolean,
    isViewResultShown: t.Boolean,
    mergeCustomer: MergeCustomerStatus,
    pageStatus: PageStatus
}, {
    defaultProps: {
        areCitiesLoaded: PageStatus.meta.map.COMPLETE,
        areStateFacetsLoaded: PageStatus.meta.map.COMPLETE,
        breadcrumbTitle: '',
        customerSearchError: new CustomerSearchError({}),
        fullPageLoadingStatus: PageStatus.meta.map.COMPLETE,
        hasSearchStarted: false,
        isRestoreDefaultFacetShown: false,
        isSaveDefaultFacetShown: false,
        isViewResultShown: false,
        mergeCustomer: new MergeCustomerStatus({}),
        pageStatus: PageStatus.meta.map.COMPLETE
    },
    name: 'ApplicationStatus',
    strict: true
});
